import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentOrdersService {
  private url = environment.api;

  constructor(private http: HttpClient) {}

  /**
   * Calls GET /api/v1/orders/{id}
   * Fetches the order details by its unique identifier.
   */
  public getOrderById(id: string): Observable<any> {
    if (!id) {
      return new Observable((observer) => {
        observer.error(new Error('id is required'));
      });
    }
    const endpoint = `${this.url}/api/v1/orders/${id}`;
    console.log('[PaymentOrdersService] fetching order by id:', endpoint);
    return this.http.get(endpoint);
  }

  public PayOrdersByTransferWithFile(
    paymentOrdersId: string,
    data: any
  ): Observable<any> {
    let urlbase = `${environment.api}/api/v1/payment/pay-orders-by-transfer-with-file/${paymentOrdersId}`;
    return this.http.post<any>(urlbase, data);
  }

  /**
   * Calls PATCH /api/v1/orders/{id}
   * Updates an existing order with a full body update.
   */
  public updateOrder(id: string, payload: any): Observable<any> {
    if (!id) {
      return new Observable((observer) => {
        observer.error(new Error('id is required'));
      });
    }
    const endpoint = `${this.url}/api/v1/orders/${id}`;
    console.log('[PaymentOrdersService] updating order by id (PATCH):', { endpoint, payload });
    return this.http.patch(endpoint, payload);
  }
}
